import MyWorkViewSettings from "./view-settings";
import {myWorkViewDictionary, MyWorkViewName, myWorkViewOptionDictionary} from "../@const";
import View from "../../../../../core/model2/view/view";
import {ViewType} from "../../../../../core/gd/const/views/view-type";
import {EntityType} from "../../../../../core/gd/const/item";
import MyWorkSubmenuItem_More from "../submenu/menu-item-more/item-more";
import myWorkToggleIsCompactMenu from "../../actions/toggle-is-compact-menu";


export default class MyWorkView extends View {

    // public sortPosition : number
    public hasMoreMenu  : boolean

    constructor(data: any) {

        super(data, ViewType.MY_WORK, EntityType.DYNAMIC_MODEL);

        this.id             = _.get(data, "id", this.defaultViewData.id)
        this.icon           = _.get(data, "icon", this.defaultViewData.icon)
        this.type           = _.get(data, "type", this.defaultViewData.type)
        this.name           = _.get(data, "name", this.defaultViewData.name)
        this.sortPosition   = _.get(data, "sortPosition", this.defaultViewData.sortPosition)

        const settings      = _.get(data, "settings", this.defaultViewData.settings)

        this.settings       = new MyWorkViewSettings(settings)

        this.hasMoreMenu    = true
    }

    // It's used only first time !!!!
    get defaultViewData() {
        if (!!gd.user.settings.views.myWork.get(gd.companyId).currentView) {

            const defaultViewId: MyWorkViewName = gd.user.settings.views.myWork.get(gd.companyId).currentView

            const option: Option = myWorkViewOptionDictionary[defaultViewId]!

            return {
                id              : defaultViewId,
                icon            : option.icon,
                type            : option.value,
                name            : myWorkViewOptionDictionary[defaultViewId as MyWorkViewName]?.label,
                sortPosition    : 0,
                settings        : gd.user.settings.views.myWork.get(gd.companyId).viewsSettings["my-work-common-settings"]
            }
        } else {
            return {
                id              : myWorkViewDictionary[ViewType.MY_WORK_VIEW_BOARD],
                icon            : "i5-board",
                type            : ViewType.MY_WORK_VIEW_BOARD,
                name            : myWorkViewOptionDictionary[MyWorkViewName.MY_WORK_VIEW_BOARD]?.label,
                sortPosition    : 0,
                // Used default settings
            }
        }
    }

    get viewMoreMenu() {
        return MyWorkSubmenuItem_More
    }

    toggleIsCompactMenu() {
        myWorkToggleIsCompactMenu()
    }


    toJSON() {
        return {
            id              : this.id,
            icon            : this.icon,
            type            : this.type,
            name            : this.name,
            sortPosition    : this.sortPosition,
            settings        : this.settings         // MyWorkViewSettings
        }
    }
}
